import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=44302b44&"
import script from "./PersonalData.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PersonalData.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44302b44')) {
      api.createRecord('44302b44', component.options)
    } else {
      api.reload('44302b44', component.options)
    }
    module.hot.accept("./PersonalData.vue?vue&type=template&id=44302b44&", function () {
      api.rerender('44302b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PersonalData.vue"
export default component.exports